import { render } from "./BeneficiaryUpdate.vue?vue&type=template&id=4fffc176&scoped=true"
import script from "./BeneficiaryUpdate.vue?vue&type=script&lang=js"
export * from "./BeneficiaryUpdate.vue?vue&type=script&lang=js"

import "./BeneficiaryUpdate.vue?vue&type=style&index=0&id=4fffc176&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fffc176"]])

export default __exports__